module.exports = __webpack_public_path__ + "img/bee.0aab19a7.png";